import { KeyOutlined, LoadingOutlined } from "@ant-design/icons";
import { Alert, Button, Col, Form, Input, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { changePassword, validateConcurrentLogin } from "../../../Actions/api";
import jwt_decode from "jwt-decode";
import Cookies from 'js-cookie';
import "./ChangePassword.css";

function ChangePassword() {
  const token = Cookies.get("JWToken");
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { message } = useSelector((state) => state.message);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (!isLoggedIn) {
      history.push("/Login");
    }
  }, [isLoggedIn]);

  const handleConcurrentLogin = (token) => {
    if (token !== undefined) {
      let concurrencyLoginStamp = localStorage.getItem('ConcurrencyLoginStamp');
      if (token && concurrencyLoginStamp) {
        var decodePayload = jwt_decode(token);
        dispatch(validateConcurrentLogin(decodePayload.uid, concurrencyLoginStamp));
      }
    }
  }

  const onFinish = async () => {
    handleConcurrentLogin(token);
    const values = await form.validateFields();
    if (values) {
      setLoading(true);
    }
    dispatch(
      changePassword(
        values.currentPassword,
        values.newPassword,
        values.confirmPassword
      )
    )
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div className="CP-container" justify="center">
      <div className="CP-title">Change Password</div>
      {/* <div className="sub-signin-title">JUST ONE STEP AWAY FROM OUR AWESOME APIs</div> */}
      {message && (
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={6} xl={6} justify="center"></Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} justify="center">
            {message && (
              <div>
                {message[0] === true ? (
                  <Alert message={message[1]} type="success" />
                ) : (
                  <Alert
                    message={
                      message[1] != null ? (
                        message[1]
                      ) : (
                        <ul style={{ paddingLeft: "20px" }}>
                          {message[2].map((m) => (
                            <li key={m}>{m}</li>
                          ))}
                        </ul>
                      )
                    }
                    type="error"
                  />
                )}
              </div>
            )}
          </Col>
        </Row>
      )}
      <Form form={form} layout="vertical" name="basic" className="CP_form">
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={6} xl={6} justify="center"></Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} justify="center">
            <Form.Item
              label={<label className="label_CP">Current Password</label>}
              name="currentPassword"
              rules={[
                {
                  required: true,
                  message: "Please input your current password!",
                },
              ]}
            >
              <Input.Password
                addonBefore={<KeyOutlined />}
                size="large"
                placeholder=""
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={6} xl={6} justify="center"></Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} justify="center">
            <Form.Item
              label={<label className="label_CP">New Password</label>}
              name="newPassword"
              rules={[
                {
                  required: true,
                  message: "Please input your new password!",
                },
                {
                  min: 8,
                  message: "New Password must be minimum 8 characters.",
                },
                {
                  pattern: "(?=.*[a-z])",
                  message: "At least one lower case",
                },
                {
                  pattern: "(?=.*[A-Z])",
                  message: "At least one Upper case",
                },
                {
                  pattern: "(?=.*[@$!%*#?&_-])",
                  message: "At least one Special Character",
                },
                {
                  pattern: "(?=.*[0-9])",
                  message: "At least one Digital Number",
                },
              ]}
            >
              <Input.Password
                addonBefore={<KeyOutlined />}
                size="large"
                placeholder=""
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={6} xl={6} justify="center"></Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} justify="center">
            <Form.Item
              label={<label className="label_CP">Confirm Password</label>}
              name="confirmPassword"
              dependencies={["newPassword"]}
              rules={[
                {
                  required: true,
                  message: "Please confirm your password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("newPassword") === value) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                addonBefore={<KeyOutlined />}
                size="large"
                placeholder=""
              />
            </Form.Item>
          </Col>
        </Row>
        <br />
        <Form.Item style={{ textAlign: "center", marginTop: "10px" }}>
          <Button
            type="primary"
            onClick={onFinish}
            size="large"
            className="button_login"
          >
            {loading && <LoadingOutlined />}
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default ChangePassword;
